import api from "./api"

export const boardService = {
    getBoards: async () => {
        try {
            const response = await api.get('/api/Board');
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || error.message || 'Erro ao buscar os quadros');
        }
    },
    getBoard: async (numBoard) => {
        try {
            const response = await api.get(`api/Board/${numBoard}`);
            return response.data;
        } catch (error) {
            throw new Error('Erro ao buscar o quadro');
        }
    },
    createBoard: async (name, emoji) => {
        try {
            const response = await api.post('api/Board', { Name: name, Emoji: emoji });
            return response.data;
        } catch (error) {
            const status = error.response?.status;
            const message = error.response?.data?.message || error.response?.data || error.message;
            throw new Error(`Erro ao criar o quadro [${status}]: ${JSON.stringify(message)}`);
        }
    },
    updateBoard: async (numBoard, name, isActive, emoji) => {
        try {
            const response = await api.put(`api/Board/${numBoard}`, {
                numBoard,
                Name: name,
                IsActive: isActive,
                Emoji: emoji
            });
            return response.data;
        } catch (error) {
            const status = error.response?.status;
            const message = error.response?.data?.message || error.response?.data || error.message;
            throw new Error(`Erro ao atualizar o quadro [${status}]: ${JSON.stringify(message)}`);
        }
    },
};

export default boardService;